module.exports = __webpack_public_path__ + "static/media/sixinarow-iphone5s-bezel-3-schedule-export.a0fca2eb.webm";